export enum ScheduleContentPlatforms {
    WEB = 'WEB',
    TEAMS = 'TEAMS',
    OUTLOOK = 'OUTLOOK'
}
